export enum AggregationState {
	UNRETRIEVED,
	RETRIEVING,
	RETRIEVED,
	FAILED,
}
